import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useToken } from "../../Components/TokenContext";

import logo from '../../assets/img/logoHeader.png';
import logoutIcon from '../../assets/img/logout.png';
import cartIcon from '../../assets/img/shopping-cart.png';

function LogoutModal({ onConfirm, onCancel }) {
    return (
        <>
            <div
                className="fixed inset-0 bg-black bg-opacity-60 z-[100] flex items-center justify-center backdrop-blur-sm"
                onClick={onCancel}
            >
                <div
                    className="bg-primary border-[4px] border-secondary rounded-2xl px-8 py-8 mx-4 max-w-sm w-full shadow-2xl font-primary animate-fade-in-down"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="flex justify-center mb-4">
                        <div className="bg-white bg-opacity-10 rounded-full p-4">
                            <img src={logoutIcon} alt="Sair" className="" />
                        </div>
                    </div>

                    <h2 className="text-white text-xl font-semibold text-center mb-2">
                        Deseja sair?
                    </h2>
                    <p className="text-white text-opacity-70 text-sm text-center mb-7 opacity-70">
                        Você será desconectado da sua conta.
                    </p>

                    <div className="flex gap-3">
                        <button
                            onClick={onCancel}
                            className="flex-1 ring-2 ring-inset ring-white text-white font-semibold py-2.5 rounded-xl transition-all hover:bg-white hover:text-primary"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={onConfirm}
                            className="flex-1 bg-tertiary text-primary font-semibold py-2.5 rounded-xl transition-all hover:opacity-80"
                        >
                            Sair
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export function Header({ isLogged = false }) {
    const navigate = useNavigate();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [notification, setNotification] = useState(null);
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const menuItemsLeft = [
        { name: "Meus Prêmios", url: "/premios/meus", hash: "", external: false },
        { name: "Solicitar Prêmios", url: "/premios", hash: "", external: false },
        { name: "Vendas e Pontuação", url: "/vendas", hash: "", external: false }
    ];

    const menuItemsRight = [
        { name: "Regulamento", url: "/regulamento", hash: "", external: false }
    ];

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const { tokenData } = useToken();

    useEffect(() => {
        if (document.querySelector('script[src*="googletagmanager"]')) return;

        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-XL1D488W32';
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-XL1D488W32');
        `;
        document.head.appendChild(script2);
    }, []);

    async function handleLogout() {
        try {
            const response = await fetch(`${baseUrl}/participante/logout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
            });

            const result = await response.json();

            if (!response.ok) {
                setNotification({
                    type: 'error',
                    message: 'Não é possível fazer logoff do usuário.',
                    show: true,
                });
                setShowLogoutModal(false);
                return;
            }

            localStorage.removeItem('user_id');
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_type');
            navigate('/participantes/login');
        } catch (error) {
            console.error(error.message);
        }
    }

    return (
        <header className="relative bg-primary top-0 left-0 right-0 z-[20] border-b-[6px] border-secondary font-primary">

            {showLogoutModal && (
                <LogoutModal
                    onConfirm={handleLogout}
                    onCancel={() => setShowLogoutModal(false)}
                />
            )}

            <div
                className={`fixed inset-0 bg-black lg:hidden duration-300 ease-out z-[1] ${isMenuOpen ? 'opacity-30' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setIsMenuOpen(false)}
            />

            <div className="container max-w-large">
                <div className="hidden lg:grid items-center h-20 xl:h-24 2xl:h-28" style={{ gridTemplateColumns: '1fr 266px 1fr' }}>
                    <nav>
                        <ul className="flex items-center gap-6 xl:gap-10 2xl:gap-14">
                            {menuItemsLeft.map((item, index) => (
                                <li key={index}>
                                    {item.external ? (
                                        <a
                                            href={item.url}
                                            className="text-white text-sm xl:text-base font-medium transition-all hover:opacity-80 whitespace-nowrap"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {item.name}
                                        </a>
                                    ) : (
                                        <Link
                                            to={item.hash ? `${item.url}#${item.hash}` : item.url}
                                            className="text-white text-sm xl:text-base font-medium transition-all hover:opacity-80 whitespace-nowrap"
                                        >
                                            {item.name}
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div className="relative w-full">
                        <div className="absolute -top-6 left-0 right-0 flex justify-center">
                            <Link to="/" className="relative">
                                <div className="absolute -left-6 top-16 xl:top-[4.5em] 2xl:top-20 -right-6 -bottom-6 bg-primary border-[6px] border-secondary border-t-0 rounded-b-[38px]" />
                                <img src={logo} alt="Logo" className="relative w-44 2xl:w-50" />
                            </Link>
                        </div>
                    </div>

                    <nav>
                        <ul className="flex items-center justify-end gap-4 xl:gap-6 2xl:gap-8">
                            {menuItemsRight.map((item, index) => (
                                <li key={index}>
                                    {item.external ? (
                                        <a
                                            href={item.url}
                                            className="text-white text-sm xl:text-base font-medium transition-all hover:opacity-80 whitespace-nowrap"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {item.name}
                                        </a>
                                    ) : (
                                        <Link
                                            to={item.hash ? `${item.url}#${item.hash}` : item.url}
                                            className="text-white text-sm xl:text-base font-medium transition-all hover:opacity-80 whitespace-nowrap"
                                        >
                                            {item.name}
                                        </Link>
                                    )}
                                </li>
                            ))}

                            {!isLogged && (
                                <>
                                    <li>
                                        <Link
                                            to="/participantes/cadastro"
                                            className="ring-2 ring-inset ring-white text-white text-sm xl:text-base font-semibold ml-4 xl:ml-0 xl:-mr-3 px-8 py-2.5 rounded-xl transition-all hover:bg-white hover:text-primary whitespace-nowrap"
                                        >
                                            Cadastrar
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/participantes/login"
                                            className="bg-tertiary text-primary text-sm xl:text-base font-semibold px-8 py-2.5 rounded-xl transition-all hover:opacity-80 whitespace-nowrap"
                                        >
                                            Entrar
                                        </Link>
                                    </li>
                                </>
                            )}

                            {tokenData && tokenData.tipo === 'participante' && (
                                <li className="relative">
                                    <Link to="/carrinho">
                                        {tokenData.carrinhoCount > 0 && (
                                            <div className="absolute inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full -top-2 -right-2">
                                                {tokenData.carrinhoCount}
                                            </div>
                                        )}
                                        <img src={cartIcon} alt="Carrinho" className="w-6 h-6" />
                                    </Link>
                                </li>
                            )}

                            {isLogged && (
                                <li>
                                    <button onClick={() => setShowLogoutModal(true)} className="block transition-all hover:opacity-80">
                                        <img src={logoutIcon} alt="Sair" className="w-6 h-6" />
                                    </button>
                                </li>
                            )}
                        </ul>
                    </nav>
                </div>

                <div className="flex lg:hidden items-center justify-between h-20 relative">
                    <div to="/" className="absolute top-4 left-1/2 -translate-x-1/2">
                        <Link to="/" className="relative">
                            <div className="absolute -left-5 top-16 -right-5 -bottom-5 bg-primary border-[6px] border-secondary border-t-0 rounded-b-[22px]" />
                            <img src={logo} alt="Logo" className="h-24 relative" />
                        </Link>
                    </div>

                    <button className="ml-auto relative z-[4]" onClick={toggleMenu}>
                        <div className="flex items-center">
                            <div className="relative w-8 h-[21px]">
                                <div
                                    className={`absolute top-0 h-[3px] w-8 bg-white rounded transition-all duration-300 ${isMenuOpen ? 'rotate-45 !top-[10px]' : ''}`}
                                    style={{ transitionProperty: 'top, transform' }}
                                />
                                <div
                                    className={`absolute top-[9px] h-[3px] w-8 bg-white rounded transition-all duration-300 ${isMenuOpen ? 'scale-x-0' : ''}`}
                                    style={{ transitionProperty: 'transform' }}
                                />
                                <div
                                    className={`absolute bottom-0 h-[3px] w-8 bg-white rounded transition-all duration-300 ${isMenuOpen ? '-rotate-45 bottom-[8px]' : ''}`}
                                    style={{ transitionProperty: 'bottom, transform' }}
                                />
                            </div>
                        </div>
                    </button>

                    <div className={`fixed z-[2] top-0 left-0 right-0 min-h-[70vh] flex items-center bg-primary bg-opacity-95 backdrop-blur-sm transition-all ease-out duration-300 ${isMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-30 pointer-events-none'}`}>
                        <nav className="container py-20">
                            <ul className="flex flex-col items-center gap-6">
                                {[...menuItemsLeft, ...menuItemsRight].map((item, index) => (
                                    <li key={index}>
                                        <Link
                                            to={item.hash ? `${item.url}#${item.hash}` : item.url}
                                            className="text-lg font-medium text-white transition-all hover:opacity-80"
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}

                                {!isLogged && (
                                    <>
                                        <li>
                                            <Link
                                                to="/participantes/cadastro"
                                                className="block border border-white text-white text-lg font-semibold px-6 py-1.5 rounded"
                                                onClick={() => setIsMenuOpen(false)}
                                            >
                                                Cadastrar
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/participantes/login"
                                                className="block bg-tertiary text-primary text-lg font-semibold px-6 py-1.5 rounded -mt-2"
                                                onClick={() => setIsMenuOpen(false)}
                                            >
                                                Entrar
                                            </Link>
                                        </li>
                                    </>
                                )}

                                <li>
                                    <button
                                        onClick={() => { setIsMenuOpen(false); setShowLogoutModal(true); }}
                                        className="flex items-center gap-2 text-white font-medium"
                                    >
                                        <img src={logoutIcon} alt="Sair" className="w-5 h-5" />
                                        Sair
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
}